// src/components/PostManager.jsx
import React, { useEffect, useState } from 'react';
import { getPosts, createPost, updatePost, patchPost } from '../api/postService';

const PostManager = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    getPosts()
      .then((response) => {
        alert(JSON.stringify(response.data))
        setPosts(response.data); // limit to 5 for display
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  const handleCreate = () => {
    const newPost = { title: 'New Post', body: 'Created via POST', userId: 1 };
    createPost(newPost).then((res) => {
      setMessage(`Created Post ID: ${res.data.id}`);
    });
  };

  const handleUpdate = () => {
    const updatedPost = { title: 'Updated Title', body: 'Updated content', userId: 1 };
    updatePost(1, updatedPost).then((res) => {
      setMessage(`Updated Post ID: ${res.data.id}`);
    });
  };

  const handlePatch = () => {
    const partialUpdate = { title: 'Patched Title' };
    patchPost(1, partialUpdate).then((res) => {
      setMessage(`Patched Post ID: ${res.data.id}`);
    });
  };

  return (
    <div>
      <h2>Posts</h2>
      {loading ? <p>Loading...</p> : (
        <ul>
          {posts.map((post) => (
            <h1 key={post.value}><strong>{post.name}/{post.value}</strong></h1>
          ))}
        </ul>
      )}
      <div style={{ marginTop: '20px' }}>
        <button onClick={handleCreate}>Create Post (POST)</button>
        <button onClick={handleUpdate}>Update Post (PUT)</button>
        <button onClick={handlePatch}>Patch Post (PATCH)</button>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default PostManager;
